export class MenuBarEvents {
    public static readonly INFO_PAGE_CLICKED: string = 'INFO_PAGE_CLICKED';
    public static readonly CLOSED: symbol = Symbol('CLOSED');
    public static readonly GAME_RULES_CLICKED: string = 'MENU_BAR_GAME_RULES_CLICKED';
    public static readonly HISTORY_BUTTON_CLICKED: string = 'MENU_BAR_HISTORY_CLICKED';
    public static readonly LOGOUT_BUTTON_CLICKED: string = 'MENU_BAR_LOGOUT_BUTTON_CLICKED';
    public static readonly SUPPORT_BUTTON_CLICKED: string = 'MENU_BAR_SUPPORT_BUTTON_CLICKED';
    public static readonly CASHIER_CLICKED: string = 'MENU_BAR_CASHIER_CLICKED';
    public static readonly OPENED: symbol = Symbol('OPENED');
    public static readonly MENU_BAR_CLOSED: symbol = Symbol('MENU_BAR_CLOSED');
}